import { Box, Typography } from '@mui/material';
import { ChartsLegend, DefaultizedPieValueType, PiePlot, pieArcLabelClasses } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';
import { processData } from './utils/processData';

export const DealerAccidentsOverviewPie = ({ graphData }: DealerAccidentsOverviewProps) => {
  const chartData = processData({ data: graphData });
  if (!chartData) return null;

  const acceptedCount = chartData?.reduce((acc, d) => acc + d.accepted, 0);
  const rejectedCount = chartData?.reduce((acc, d) => acc + d.rejected, 0);

  const pieData = [
    {
      label: `Řešené nehody (${acceptedCount})`,
      value: acceptedCount,
      color: 'green'
    },
    {
      label: `Neřešené nehody (${rejectedCount})`,
      value: rejectedCount,
      color: '#C62327'
    }
  ];

  const getArcLabel = (params: DefaultizedPieValueType) => {
    return params.value.toString();
  };

  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Řešené a neřešené nehody
          </Typography>
          <Typography variant="body2" color="gray">
            Agregovaný přehled mých nehod
          </Typography>
        </>
      }
    >
      <Box width={1} height="300px">
        <ResponsiveChartContainer
          skipAnimation
          margin={{ bottom: 90 }}
          series={[
            {
              type: 'pie',
              data: pieData,
              arcLabel: getArcLabel
            }
          ]}
          sx={{
            [`& .${pieArcLabelClasses.root}`]: {
              fill: 'white',
              fontSize: 14
            }
          }}
        >
          <PiePlot />
          <ChartsLegend position={{ vertical: 'bottom', horizontal: 'middle' }} />
        </ResponsiveChartContainer>
      </Box>
    </BoxWithHeader>
  );
};
